module.exports = __webpack_public_path__ + "static/solution9-d3c3533e7437a08e5be148ff9268f625.png";